import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./Layout.css";

const AppLayout = ({ children }) => {
  return (
    <div className="layout-container">
      <Sidebar />

      <div className="layout-main">
        <Navbar />

        <div className="layout-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppLayout;